export class AjaxTimeoutError extends Error {
    constructor(timeoutMs){
        super("Timeout"), this.timeoutMs = timeoutMs;
        this.name = "AjaxTimeoutError";
    }
}
function hasErrorName(error, name) {
    return typeof error === "object" && error !== null && "name" in error && error.name === name;
}
export function classifyTransportFailure(error) {
    if (error instanceof AjaxTimeoutError) {
        return "client_timeout";
    }
    if (error instanceof TypeError) {
        return "fetch_rejection";
    }
    if (hasErrorName(error, "AbortError")) {
        return "caller_abort";
    }
    return "unknown_no_response";
}
export function getTransportFailureTelemetry(error) {
    const telemetry = {
        transportFailureKind: classifyTransportFailure(error)
    };
    if (error instanceof AjaxTimeoutError) {
        telemetry.configuredTimeoutMs = String(error.timeoutMs);
    }
    return telemetry;
}
